import React from 'react';
import T from 'prop-types';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';

import { Layout, Container } from './style';

interface StaticProps {
  children: React.ReactNode;
}

const Static: React.FC<StaticProps> = ({ children }) => (
  <>
    <Navbar />
    <Layout>
      <Layout.Content>
        <Container>{children}</Container>
      </Layout.Content>
      <Footer />
    </Layout>
  </>
);

Static.propTypes = {
  children: T.node.isRequired,
};

export default Static;
